<div id="keyboard" *ngIf="visible">
    <div class="row">
        <div *ngFor="let num of numbers; let i = index" [ngClass]="i==8?'col-3 d-flex align-items-center justify-content-center offset-3': 'col-3 d-flex align-items-center justify-content-center'">
            <div class="circle" (click)="send(num, i)">
                {{num}}
            </div>
        </div>
        <div class="col-3 d-flex align-items-center justify-content-center">
            <img src="/assets/images/del.svg" alt="" (click)="del()">
        </div>
    </div>
</div>